export const currentColumnsSettingsSelector = (state) => state.get('columnsSettings');
